import axios from 'axios';

// Import prodotti dai siti delle marche (backend: /api/v1/brandimport).
// Tutte le azioni ritornano il body della risposta oppure { error }.

const richiesta = async (context, method, url, data, params) => {
	return await axios({
		method,
		url: `${context.rootGetters['settings/getUrl']}brandimport/${url}`,
		data,
		params,
		headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}`, 'Content-Type': 'application/json' },
	})
		.then(res => res.data)
		.catch(err => ({ error: err.response ? err.response.data : err.message }));
};

const actions = {
	fetchBrands: context => richiesta(context, 'get', 'brands'),
	fetchOptions: context => richiesta(context, 'get', 'options'),

	fetchConfig: (context, brandId) => richiesta(context, 'get', `config/${brandId}`),
	saveConfig: (context, { brandId, config }) => richiesta(context, 'put', `config/${brandId}`, config),

	fetchRules: (context, rulesId) => richiesta(context, 'get', `rules/${rulesId}`),
	// crawl undefined = non inviato (il backend lascia la navigazione com'è); null = rimuove
	updateRules: (context, { rulesId, fields, crawl }) => richiesta(context, 'put', `rules/${rulesId}`, crawl === undefined ? { fields } : { fields, crawl }),
	activateRules: (context, rulesId) => richiesta(context, 'post', `rules/${rulesId}/activate`),
	createRules: (context, payload) => richiesta(context, 'post', 'rules', payload),
	fetchSnapshot: (context, snapshotId) => richiesta(context, 'get', `snapshots/${snapshotId}`),

	// type: generate_rules | preview_rules | scan
	createJob: (context, payload) => richiesta(context, 'post', 'jobs', payload),
	// pagine che la scansione non legge: action = exclude | dismiss | include | retry
	pagesAction: (context, { brandId, action, urls }) => richiesta(context, 'post', `config/${brandId}/pages/${action}`, { urls }),
	fetchJobs: (context, params) => richiesta(context, 'get', 'jobs', null, params),
	fetchJob: (context, jobId) => richiesta(context, 'get', `jobs/${jobId}`),
	cancelJob: (context, jobId) => richiesta(context, 'post', `jobs/${jobId}/cancel`),

	// Importa da URL nella creazione prodotto: { url, fetchMode } -> job url_import (polling con fetchJob)
	urlImportStart: (context, payload) => richiesta(context, 'post', 'url-import', payload),
	// immagini scelte -> S3, nel formato del form di creazione
	urlImportImages: (context, urls) => richiesta(context, 'post', 'url-import/images', { urls }),
	// tag letti dalla pagina -> tag del catalogo [{ _id, name, nuovo }], quelli che mancano vengono creati
	urlImportTags: (context, names) => richiesta(context, 'post', 'url-import/tags', { names }),
	// Cerca online nella creazione prodotto: { ean, brand, name } -> job web_search (polling con fetchJob),
	// poi le pagine trovate con fetchSearch(job.search)
	webSearchStart: (context, payload) => richiesta(context, 'post', 'web-search', payload),
	fetchSearch: (context, searchId) => richiesta(context, 'get', `searches/${searchId}`),
	// Suggerisci URL: { searchId, url } -> job web_search che aggiunge la pagina ai risultati
	suggestSearchUrl: (context, { searchId, url }) => richiesta(context, 'post', `searches/${searchId}/url`, { url }),

	fetchProducts: (context, params) => richiesta(context, 'get', 'products', null, params),
	fetchProduct: (context, id) => richiesta(context, 'get', `products/${id}`),
	updateProduct: (context, { id, payload }) => richiesta(context, 'put', `products/${id}`, payload),
	rejectProducts: (context, ids) => richiesta(context, 'post', 'products/reject', { ids }),
	restoreProducts: (context, ids) => richiesta(context, 'post', 'products/restore', { ids }),
	rewriteFiltered: (context, { brandId, filter }) => richiesta(context, 'post', 'products/rewrite-filtered', { brandId, filter }),
	seoSummary: (context, { ids }) => richiesta(context, 'post', 'products/seo-summary', { ids }),
	rewriteProducts: (context, { brandId, ids }) => richiesta(context, 'post', 'products/rewrite', { brandId, ids }),
	translateProducts: (context, { brandId, ids }) => richiesta(context, 'post', 'products/translate', { brandId, ids }),
	rescanProducts: (context, { brandId, ids }) => richiesta(context, 'post', 'products/rescan', { brandId, ids }),
	approveProducts: (context, payload) => richiesta(context, 'post', 'products/approve', payload),
	// tutti i prodotti importabili con i filtri della lista (fino a 500 per volta)
	approveFiltered: (context, payload) => richiesta(context, 'post', 'products/approve-filtered', payload),
};

export default {
	namespaced: true,
	state: {},
	mutations: {},
	getters: {},
	actions,
};
